
// - Basic settings - //

  // server
  export const API_URL = 'https://api.frydlant.qtcloud.cz';//'http://192.168.1.190:3000'; //'http://31.31.72.155:3012'; // 'https://private-49bf01-qtcloudweborderv2.apiary-mock.com'; // 'ht$

  // Google maps api key
  export const GOOGLE_API_KEY = 'AIzaSyCFn5kJ0M9ANeXrgVLgOiQLgCdetZgJGXo';

  // google recapcha v2
  export const CAPRCHA_CLIENT_KEY = '6LchWxYUAAAAAHS5JBSMFlSP3Fu-uHNr47WYzU0W';

  // title
  export const APP_TITLE = ''; // 'Rezervační systém'

  // single office mode
  export const SINGLE_OFFICE_MODE = true;

  // graph statistics
  // - default: month or year
  export const STATS_DEFAULT_SETTING = 'year';
  // - if switching is bad idea
  export const STATS_SHOW_DATE_SWITCH = true;

// -------------------- //


// ~ Colors ~ //

  // color 1
  //  - main color in header and selected button
  export const COLOR_1 = '#0a4e66';
  export const COLOR_1_BORDER_BOTTOM = 'rgb(14, 94, 122)';
  export const COLOR_1_BORDER_LEFT = 'rgb(15, 94, 122)';

  // color 2
  // - color in header under logo
  export const COLOR_2 = '#003c4c';
  export const COLOR_2_BORDER_BOTTOM = 'rgb(9, 84, 104)';
  export const COLOR_2_BORDER_RIGHT = 'rgb(5, 91, 114)';

  // color 3
  //  - side panel color
  export const COLOR_3 = '#2e3647';
  export const COLOR_3_BORDER_RIGHT = 'rgba(73, 79, 94, 0.71)';

// -------------------- //
